import { assignExistingUser, ExistingUserAssignModel } from "@carotek/Services/CreateAccountAssignExistingUserService";
import {
    ApiHandler,
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

type ExistingUserAssignParameter = {
    email: string;
} & HasOnSuccess &
    HasOnError;

type CustomHandlerType = ApiHandlerDiscreteParameter<ExistingUserAssignParameter, ExistingUserAssignModel, any>;

export const CustomPopulateApiParameter: CustomHandlerType = props => {
    props.apiParameter = {
        email: props.parameter.email,
    };
};

export const SendDataToApi: CustomHandlerType = async props => {
    try {
        const result = await assignExistingUser(props.apiParameter);
        props.apiResult = {
            success: true,
            data: result,
        };
    } catch (err) {
        props.apiResult = {
            success: false,
            data: err,
        };
    }
};

export const ExecuteOnErrorCallback: CustomHandlerType = props => {
    if (!props.apiResult.success) {
        props.parameter.onError?.(props.apiResult.err);
    }
};

export const ExecuteOnSuccessCallback: CustomHandlerType = props => {
    if (props.apiResult.success) {
        props.parameter.onSuccess?.(props.apiResult.data);
    }
};

const userCheckChain = [CustomPopulateApiParameter, SendDataToApi, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const assignExistingUserWebsite = createHandlerChainRunner(userCheckChain, "CheckUserExistsByEmail");
export default assignExistingUserWebsite;
